import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

// setTimeout overflows (and fires immediately) above this delay
const MAX_TIMEOUT = 2147483647;

// Expiry in ms, or null when the token is not a JWT with an exp claim
// and can only be checked for presence
const getTokenExpiry = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return typeof exp === "number" ? exp * 1000 : null;
  } catch {
    return null;
  }
};

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const token = sessionStorage.getItem("token");
  const expiry = token ? getTokenExpiry(token) : null;
  const [expired, setExpired] = useState(false);
  const isAuthenticated =
    Boolean(token) && !expired && (expiry === null || expiry > Date.now());

  useEffect(() => {
    if (!isAuthenticated) {
      sessionStorage.clear();
      return;
    }
    if (expiry === null) return;

    // Log out as soon as the token expires, even if the user stays on the page
    const delay = expiry - Date.now();
    if (delay > MAX_TIMEOUT) return;
    const timer = setTimeout(() => setExpired(true), delay);
    return () => clearTimeout(timer);
  }, [isAuthenticated, expiry]);

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AuthGuard;
